import { render, staticRenderFns } from "./getLabel.vue?vue&type=template&id=25fb7757&scoped=true"
import script from "./getLabel.vue?vue&type=script&lang=js"
export * from "./getLabel.vue?vue&type=script&lang=js"
import style0 from "./getLabel.vue?vue&type=style&index=0&id=25fb7757&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb7757",
  null
  
)

export default component.exports